import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { TeamStructureContainer } from './containers/team-structure/team-structure.container';
import { TeamsListContainer } from './containers/teams-list/teams-list.container';
import { AssignmentSettingsContainer } from './containers/assignment-settings/assignment-settings.container';

export const TeamModule: React.FC = () => {
  // Read at render time, never as a module-level const — see LeadModule for
  // why that distinction took the admin app down once already.
  const children = APP_ROUTES.TEAM_MODULE.CHILDREN as RouteConfig;

  return (
    <>
      <Route exact path={APP_ROUTES.TEAM_MODULE.FULL_PATH}>
        <Redirect to={children.STRUCTURE.FULL_PATH} />
      </Route>
      <Route path={children.STRUCTURE.FULL_PATH} component={TeamStructureContainer} />
      <Route path={children.LIST.FULL_PATH} component={TeamsListContainer} />
      <Route path={children.ASSIGNMENT.FULL_PATH} component={AssignmentSettingsContainer} />
    </>
  );
};
